"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QualifiersList = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

var isUnknown = function isUnknown(value) {
  return String(value).toLowerCase() === 'unknown';
};

var QualifierDescriptionWithIcon = _styledComponents["default"].div.withConfig({
  displayName: "QualifierDescriptionWithIcon",
  componentId: "sc-uq46y3-0"
})(["display:grid;grid-template-columns:auto 1fr;align-items:center;"]);

var qualifierIconLookup = {
  fail: {
    icon: 'actions/circle-delete',
    color: _baseReactComponents.theme.sebastianRed200
  },
  unknown: {
    icon: 'actions/circle-faq',
    color: _baseReactComponents.theme.scuttleGray400
  },
  pass: {
    icon: 'actions/check-circle',
    color: _baseReactComponents.theme.seaturtleGreen200
  }
};
var StyledIcon = (0, _styledComponents["default"])(_baseReactComponents.Icon).withConfig({
  displayName: "StyledIcon",
  componentId: "sc-uq46y3-1"
})(["fill:", ";margin-right:8px;"], function (_ref) {
  var color = _ref.color;
  return color;
});

var TooltipContainer = _styledComponents["default"].div.withConfig({
  displayName: "TooltipContainer",
  componentId: "sc-uq46y3-2"
})(["display:flex;span{padding-bottom:0;}"]);

var iconLabels = {
  pass: 'You meet the requirements',
  unknown: 'Unknown',
  fail: 'You don’t meet the requirements'
};

var QualifiersList = function QualifiersList(_ref2) {
  var qualifiers = _ref2.qualifiers,
      showExtrapolatedToolTip = _ref2.showExtrapolatedToolTip;

  var _useInfoDrawer = (0, _baseReactComponents.useInfoDrawer)(),
      setInfoDrawer = _useInfoDrawer.setInfoDrawer;

  if (!(qualifiers !== null && qualifiers !== void 0 && qualifiers.length)) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: qualifiers === null || qualifiers === void 0 ? void 0 : qualifiers.map(function (qualifier, index) {
      var _qualifierIconLookup$, _iconLabels$qualifier;

      var qualifierIcon = (_qualifierIconLookup$ = qualifierIconLookup[qualifier.evaluation]) !== null && _qualifierIconLookup$ !== void 0 ? _qualifierIconLookup$ : qualifierIconLookup.unknown;
      var fallbackIconLabel = (_iconLabels$qualifier = iconLabels[qualifier.evaluation]) !== null && _iconLabels$qualifier !== void 0 ? _iconLabels$qualifier : iconLabels.unknown;
      var iconLabel = qualifier.link && qualifier.shortText || fallbackIconLabel;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          bold: true,
          children: qualifier.title
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(TooltipContainer, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
            className: "js-private",
            "data-heap-redact-text": "true",
            children: isUnknown(qualifier.value) ? '' : qualifier.value
          }), showExtrapolatedToolTip && qualifier.title === 'Annual Revenue' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.AdvertiserDisclosure, {
            buttonTitle: "",
            cardTitle: "Annual Revenue",
            cardText: "Nav broke out our calculator to estimate this figure from the 12 months of your bank data. Based on our partnerships with lenders, we believe some of them may use this representative number for your annual revenue.",
            openInfoDrawer: function openInfoDrawer(_ref3) {
              var title = _ref3.title,
                  children = _ref3.children;
              return setInfoDrawer({
                isOpen: true,
                title: title,
                content: children
              });
            }
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(QualifierDescriptionWithIcon, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
            name: qualifierIcon.icon,
            color: qualifierIcon.color
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
            children: qualifier.link ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Link, {
              target: "_self",
              to: qualifier.link,
              children: iconLabel
            }) : iconLabel
          })]
        })]
      }, index);
    })
  });
};

exports.QualifiersList = QualifiersList;
//# sourceMappingURL=qualifiers-list.js.map